import { User } from 'lucide-react';
import { toast } from 'sonner';

import { Container } from '@/components/custom/container';
import { Avatar } from '@/components/ui/avatar';
import { Button } from '@/components/ui/button/button';
import { DropdownMenuSeparator } from '@/components/ui/dropdown-menu';
import { useStore } from '@/stores';
import { STORAGE_KEY } from '@/stores';

import MenuProfileLink from './menu-profile-link';

const MenuProfile = () => {
  const userProfile = useStore((state) => state.profile);

  const signOut = () => {
    localStorage.removeItem(STORAGE_KEY);
    toast.success('Logout successful');
    setTimeout(() => window.location.replace('/auth/login'), 500);
  };

  return (
    <div className="flex w-[320px] flex-col gap-3 p-5">
      <div className="flex flex-row items-center">
        <Avatar
          data-testid="user-avatar-profile"
          className="bg-brand-blue h-11 w-11 items-center justify-center"
        >
          <span className="text-xl font-bold text-white capitalize">
            {userProfile?.name.charAt(0) || '-'}
          </span>
        </Avatar>
        <div className="ml-2 flex flex-col justify-between leading-6">
          <p className="font-semibold">{userProfile?.name ?? '-'}</p>
          <p className="max-w-44 truncate overflow-hidden">{userProfile?.email ?? '-'}</p>
          <p className="font-bold capitalize">{userProfile?.business.name ?? '-'}</p>
        </div>
      </div>
      <DropdownMenuSeparator />
      <Container direction="column" spacing={4}>
        {userProfile?.business.status === 'ACTIVE' && (
          <>
            <MenuProfileLink
              primary="My Profile"
              secondary="Account Settings"
              icon={User}
              path="/profile"
            />
          </>
        )}
        <Button
          onClick={() => signOut()}
          variant="outline"
          className="w-full cursor-pointer border-blue-200 font-semibold text-blue-400 hover:border-blue-400 hover:bg-transparent hover:text-blue-400"
        >
          {/* {isPending ? <div>loading</div> : 'LOGOUT'} */}
          LOGOUT
        </Button>
      </Container>
    </div>
  );
};

export default MenuProfile;
